import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IInterventionCount } from 'models/Intervention';

import { IInterventionData } from '../../initialState';

interface IGetAllInterventionsSuccessWithoutDataAction {
  message: string;
  count: IInterventionCount;
}

function getAllSuccessWithoutData(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IGetAllInterventionsSuccessWithoutDataAction>,
) {
  draft.getAll.config.emptyMsg = action.payload.message;
  draft.getAll.config.isLoading = false;
  draft.getAll.list = [];
  draft.getAll.config.count = action.payload.count;
}

export default getAllSuccessWithoutData;
